import { Component, Directive } from "@angular/core";

import { ConfigurationProvider } from '../../providers/providers';

@Component({
  selector: 'app-header',
  templateUrl: 'app-header.html',
})
@Directive({
  selector: "app-header"
})
export class AppHeader {
  AppName: string = 'fitbytes';
  AppVersion: string = '0.3.1';
  LogoSrc: string = 'assets/img/favicon.png';
  constructor(private config: ConfigurationProvider) {
  }
  swipeEvent() {
    this.config.showToast(this.AppVersion);
  }
}


// WEBPACK FOOTER //
// ./src/components/app-header/app-header.ts